import styled from 'styled-components';
import { Container } from "@mui/material";
import { FormControl } from "@mui/material";

export const PageContainer = styled(Container)`
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    border-radius: 0.5rem;
    border: 1px solid #E0E0E0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
    height: calc(100vh - 56px);
    overflow-y: auto;
    padding-bottom: 80px;
    position: relative;
`;

export const SectionContainer = styled.div<{ isPaymentDetails?: boolean }>`
    background-color: ${props => props.isPaymentDetails ? '#F8F9FA' : 'transparent'};
    border-radius: ${props => props.isPaymentDetails ? '0.5rem' : '0'};
    padding: 0.5rem;
    margin-bottom: ${props => props.isPaymentDetails ? '2rem' : '0'};
    h2 {
        font-size: 1rem;
        font-weight: 600;
        margin-bottom: 1rem;
        color: rgba(0, 0, 0, 0.87);
    }

    label {
        color: rgba(0, 0, 0, 0.6);
        font-size: 0.875rem;
        margin-bottom: 0.5rem;
        display: block;
    }
`;

export const TimeInputField = styled.div`
    margin-bottom: 1rem;
    
    .MuiOutlinedInput-root {
        background-color: white;
        border-radius: 4px;
        height: 48px;
    }

    .MuiInputLabel-root {
        color: rgba(0, 0, 0, 0.6);
        font-size: 0.875rem;
    }

    .MuiSelect-select {
        padding: 8px 14px;
    }
`;

export const BillingRow = styled('div')<{ isTotalAmount?: boolean }>`
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    color: rgba(0, 0, 0);
    font-size: 0.875rem;
    line-height: 1.5;
    ${props => props.isTotalAmount && `
        font-weight: 600;
    `}
    .stripe-active {
        color: var(--success-main);
        font-weight: 600;
    }
    .stripe-inactive {
        color: var(--info-main);
        text-align: right;
    }
`;

export const GHRNotificationRow = styled(BillingRow)`
    color: #2e7d32;
    font-style: italic;
    font-size: 0.9rem;
    background-color: #e8f5e9;
    padding: 8px 12px;
    border-radius: 4px;
    margin-top: 0.5rem;
    
    border-left: 3px solid #2e7d32;
    
    span {
        font-weight: 600;
    }

    .amount {
        font-weight: 600;
        margin-left: 4px;
    }

    .info-icon {
        font-size: 16px;
        margin-left: 8px;
        opacity: 0.7;
        cursor: help;
    }
`;

export const TotalAmount = styled(BillingRow)`
    font-weight: 600;
    margin-top: 1rem;
    font-size: 1rem;
`;

export const EditableContent = styled.div`
    &[contenteditable="true"] {
        border-bottom: 1px dashed var(--primary-blue);
        padding: 0 4px;
        outline: none;
        min-width: 100px;
    }
`;

export const InlineEditContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    flex-wrap: wrap;
`;

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    
    h2 {
        margin: 0;
    }

    .invoice-number {
        font-size: 1rem;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.87);
    }
`;

export const CompactFormControl = styled(FormControl)`
    width: min(300px, 100%);
    margin-right: 8px;
    display: inline-flex;
    
    .MuiInputBase-root {
        background: transparent;
        font-size: inherit;
        padding: 0;
        margin: 0;
        height: auto;
        min-height: unset;
        width: 100%;
        
        input {
            padding: 0;
            border: none;
            border: 1px solid var(--primary-blue);
            background: transparent;
            height: 24px;
            line-height: 24px;
            width: 100%;
            &:focus {
                outline: none;
            }
        }
    }
    
    .MuiOutlinedInput-notchedOutline {
        border: none;
    }
    
    .MuiAutocomplete-popper {
        margin-top: 4px;
    }

    @media (max-width: 600px) {
        width: 100%;
        margin-right: 0;
    }
`;